import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import requestIdleCallback from 'lib/requestIdleCallback'
import useStableObjectReference from './useStableObjectReference'

/**
 * Preloads a translation namespace, or multiple namespaces.
 * Use this when you expect a user to navigate to a page, open a modal, etc.
 * that uses a translation namespace that has not yet been loaded.
 *
 * @param ns Namespace(s) to preload. Can be a string or an array of strings.
 * @param enabled Whether or not to preload the namespace(s). Defaults to true.
 */
export default function usePreloadTranslation(
  /** Namespace(s) to preload */
  ns: string | readonly string[],
  enabled: boolean = true,
) {
  const { i18n } = useTranslation('common')
  const nsStable = useStableObjectReference(ns)

  useEffect(() => {
    if (enabled && !i18n.hasLoadedNamespace(nsStable)) {
      requestIdleCallback(() => {
        i18n.loadNamespaces(nsStable)
      })
    }
  }, [enabled, i18n, nsStable])
}
